import { render } from "./LaborersType.vue?vue&type=template&id=fde046de&scoped=true"
import script from "./LaborersType.vue?vue&type=script&lang=js"
export * from "./LaborersType.vue?vue&type=script&lang=js"

import "./LaborersType.vue?vue&type=style&index=0&id=fde046de&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fde046de"],['__file',"src/views/h5/luqiao/home/sichuanluqiao/LaborersType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fde046de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fde046de', __exports__)) {
    api.reload('fde046de', __exports__)
  }
  
  module.hot.accept("./LaborersType.vue?vue&type=template&id=fde046de&scoped=true", () => {
    api.rerender('fde046de', render)
  })

}


export default __exports__